<template>
    <FilterFlyout
        :name="$t('results.filtering.term')"
        :isActive="filterActive"
        :isModified="filterModified"
        @save="save"
        @clear="clear"
    >
        <div class="row term">
            <div class="col-6" v-for="(term, index) in displayTerms" :key="index">
                <button
                    :class="['btn button bordered filter-option-button', { active: termSelected(term.months) }]"
                    @click="toggleTermSelected(term.months)"
                >
                    {{ term.display }}
                </button>
            </div>
        </div>
    </FilterFlyout>
</template>

<script>
import { useStore, mapGetters } from 'vuex'
import useFilterBase from '@js/composables/filterBase.js'

// lodash components
import isEqual from 'lodash/isEqual'
import indexOf from 'lodash/indexOf'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import forEach from 'lodash/forEach'
import find from 'lodash/find'

export default {
    setup() {
        const store = useStore()

        return {
            store,
            ...useFilterBase(store),
        }
    },

    data() {
        return {
            editingLoanTerms: [],
            activeLoanTerms: [],
            optionGreaterThanMonths: 60,
        }
    },

    mounted() {
        this.filterState.save = this.save
        this.filterState.clear = this.clear
        this.filterState.filterItem = this.filterItem
    },

    computed: {
        ...mapGetters(['offerResultDataFilters']),
        filterModified() {
            this.filterState.isModified = !isEqual(this.activeLoanTerms, this.editingLoanTerms)
            return this.filterState.isModified
        },
        filterActive() {
            this.filterState.isActive = !isEmpty(this.activeLoanTerms)
            return this.filterState.isActive
        },
        displayTerms() {
            let hasOverLimit = false
            const displayTerms = []
            forEach(this.offerResultDataFilters.loan_terms, (srcTerm, index) => {
                if (srcTerm > this.optionGreaterThanMonths) {
                    hasOverLimit = true
                } else {
                    const months = srcTerm
                    if (months) {
                        displayTerms.push({
                            display:
                                `${months} ` +
                                (months === 1
                                    ? this.$t('results.filtering.month')
                                    : this.$t('results.filtering.months')),
                            months: srcTerm,
                        })
                    }
                }
            })

            if (hasOverLimit) {
                displayTerms.push({
                    display:
                        `${this.convertToYearsExact(this.optionGreaterThanMonths)}+ ` +
                        this.$t('results.filtering.years'),
                    months: `>${this.optionGreaterThanMonths}`,
                })
            }

            return displayTerms
        },
    },

    methods: {
        filterItem(offer) {
            return find(this.activeLoanTerms, function (term) {
                const termString = term.toString()
                if (termString.charAt(0) === '>') {
                    return offer.term > termString.substr(1)
                }

                return offer.term === term
            })
        },
        toggleTermSelected(term) {
            let searchValue = term
            if (term > this.optionGreaterThanMonths) {
                searchValue = `>${this.optionGreaterThanMonths}`
            }

            const index = indexOf(this.editingLoanTerms, searchValue)
            if (index >= 0) {
                this.editingLoanTerms.splice(index, 1)
            } else {
                this.editingLoanTerms.push(searchValue)
            }
        },
        termSelected(term) {
            if (term > this.optionGreaterThanMonths) {
                return indexOf(this.editingLoanTerms, `>${this.optionGreaterThanMonths}`) >= 0
            }

            return indexOf(this.editingLoanTerms, term) >= 0
        },
        save() {
            this.activeLoanTerms = cloneDeep(this.editingLoanTerms)

            this.trackEvent('event', {
                eventCategory: 'filtering',
                eventAction: 'submit',
                eventLabel: 'terms',
            })
        },
        clear() {
            this.editingLoanTerms = []
            this.save()
        },
        convertToYearsExact(months) {
            if (months % 12 > 0) {
                return 0
            }

            return months / 12
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/gutter-size';
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/settings/variables';

.term {
    @include resize-gutter(20px);
    margin-bottom: -12px;

    .button {
        margin-bottom: 12px;
    }
}
</style>
